const isNegation = (operator) => [ 'NOT_MATCH', 'NOT_IN', 'NOT_IN_RANGE', ].includes(operator)

const isFilterComplete = ({ field, operator, value, }) => field && operator && value !== ''

const getValue = (dataType, value) => {
  const forResource = (v) => {
    return Array.isArray(v) ? v.map((item) => item.code || item.lei) : v.code || v.lei
  }
  return dataType === 'RESOURCE' || dataType === 'RESOURCE_IN' ? forResource(value) : processingValue(value)
}

export const processingValue = (v) => {
  const replaceComma = (s) => (typeof s === 'string' || s instanceof String) ? s.replace(/,/g, '\\,') : s
  return Array.isArray(v) ? v.map((item) => replaceComma(item)) : replaceComma(v)
}

const generateValuePrefix = ({ operator, field, value, dataType, }) => {
  const prefixer = {
    'MATCH': (v) => v,
    'NOT_MATCH': (v) => v,
    'LESS_THAN': (v) => `<${v}`,
    'LESS_THAN_OR_EQUAL': (v) => `<=${v}`,
    'GREATER_THAN': (v) => `>${v}`,
    'GREATER_THAN_OR_EQUAL': (v) => `>=${v}`,
    'IN': (v) => v.join(','),
    'NOT_IN': (v) => v.join(','),
    'IN_RANGE': (v) => v.join('..'),
    'NOT_IN_RANGE': (v) => v.join('..'),
  }
  const newVal = operator && value ? prefixer[operator](getValue(dataType, value)) : ''

  if (newVal === '') throw new Error(`Unsupported operator '${operator}'`)
  else return isNegation(operator) ? `!${newVal}` : newVal
}

const generateFilter = (filter) => {
  return isFilterComplete(filter) ? { [filter.field.field]: generateValuePrefix(filter), } : null
}

const arrayOfCompletedFilters = (filters) => {
  return filters.map((filter) => generateFilter(filter)).filter((v) => v)
}

export const processingFilters = (filters) => arrayOfCompletedFilters(filters)
  .reduce((acc, item) => Object.assign(acc, item), {})



// WEBPACK FOOTER //
// ./src/utils/filters-pre-processor.js